import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "#/hooks/use-auth";
import { queryKeys } from "#/hooks/query-keys";
import { withdrawReferrals } from "#/lib/api/referrals";

/**
 * Sweep-style withdrawal: no amount argument. The server takes the user's
 * entire claimable balance and queues an Arbitrum USDC payout to the
 * wallet they authenticated with. We invalidate both the stats query
 * (so claimable_usd updates to 0) and the withdrawals list (so the new
 * pending row appears immediately).
 */
export function useWithdrawReferrals() {
	const queryClient = useQueryClient();
	const { userId } = useAuth();

	return useMutation({
		mutationFn: () => withdrawReferrals(),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: queryKeys.referrals.myStats(userId),
			});
			queryClient.invalidateQueries({
				queryKey: queryKeys.referrals.myWithdrawals(userId),
			});
		},
	});
}
